<app-facet-expansion-panel
  [facetKey]="facetKey"
  [count]="_checked ? 1: 0"
  [expanded]="expanded"
  [blockName]="facetBlockName"
  [attr.data-automation-id]="facetKey">
  <div>
    <div class="spinner-container" *ngIf="isLoading | async">
      <div class="spinner-border text-primary"
           role="status"
           data-automation-id="facet-spinner">
        <span class="sr-only" translate>Loading...</span>
      </div>
    </div>
    <fieldset *ngIf="!(isLoading | async)" class="facet pl-0 pr-8">
      <legend class="cdk-visually-hidden">{{facetBlockName}}</legend>
      <div class="facet-line" [ngClass] = "{'can-hover': (dateTo || dateFrom)}">
        <ng-container>
          <button class="facet-lock position-absolute p-0 ml-n3"
                  (click)="onToggleBubbleLock()"
                  [ngClass]="{'hide': !_checked}"
                  aria-label="Lock"
                  data-automation-id="date-facet-lock-btn">
            <span [ngClass]="isResetLocked ? 'icon-lock' : 'icon-lock-open'"></span>
          </button>
        </ng-container>
        <ins-bs-checkbox class="facet-checkbox"
                         [checked]="_checked"
                         [disabled] = "!dateTo && !dateFrom"
                         [ngClass]="{'selected': _checked, 'hide': !dateFrom && !dateTo}"
                         (change)="onChange($event.checked)"
                         [aria-label]="'From' + dateFrom + 'to' + dateTo"
                         data-automation-id="select-dates-checkbox">
        </ins-bs-checkbox>
        <ng-container>
          <div class="form-group">
            <label class="input-label pl-0" for="dateFromInput" [ngClass]="{'hide': !dateFrom}">
              {{ 'dateFromPlaceholder' | translate }}
            </label>
            <div class="input-group flex-nowrap from-input ml-0">
              <input type="text" class="form-control p-0 input-text"
                     id="dateFromInput"
                     [year]="dateFrom"
                     [value]="dateFrom"
                     (yearChange)="onDateFromYearChange($event)"
                     placeholder="{{ 'dateFromPlaceholder' | translate }}"
                     data-automation-id="date-from-input"
                     aria-label="Choose date from">
              <div *ngIf="dateFrom"  class="input-group-append">
                <button class="btn date-facet-btn"
                        type="button"
                        aria-label="Clear date from"
                        data-automation-id="date-from-clear-button"
                        (click)="onDateFromClear()">
                  <span class="icon-close"></span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="form-group">
            <label class="input-label pl-3" for="dateToInput"  [ngClass]="{'hide': !dateTo}">
              {{ 'dateToPlaceholder' | translate }}
            </label>
            <div class="input-group flex-nowrap to-input ml-3" >
              <input type="text" class="form-control p-0 input-text"
                     id="dateToInput"
                     [year]="dateTo"
                     [value]="dateTo"
                     (yearChange)="onDateToYearChange($event)"
                     placeholder="{{ 'dateToPlaceholder' | translate }}"
                     data-automation-id="date-to-input"
                     aria-label="Choose date to">
              <div *ngIf="dateTo"  class="input-group-append">
                <button class="btn date-facet-btn"
                        type="button"
                        aria-label="Clear date to"
                        data-automation-id="date-to-clear-button"
                        (click)="onDateToClear()">
                  <span class="icon-close"></span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </fieldset>
  </div>
</app-facet-expansion-panel>
